module.exports = __webpack_public_path__ + "img/gm-tittle.e2a29394.png";